import api from '@/api'
 
interface ResponseWrapper<TResult> {
    result: TResult
    code: string
    message: string
    error: string | null
  }

export interface WorkflowRequestDocumentBox {
    menuId: number;
    personCode: string;
    comCode?: string;
    deptCode: string;
    searchSortCategory?: number;
    searchValue: number;
    searchText: string;
    searchApmStatus?: string | null;
    itemsPerPage: number;
    page: number;
    startDate: Date;
    endDate: Date;
    applicationId: number;
    transferType?: string; // 열람 조회 대상(부서 : 문서함 종류, 개인 : 문서 종류)
    targetCode?: string | null; // 열람 대상 코드
}

export interface WorkflowResponseDocumnetBoxItem {
    currentPage: number;
    totalCount: number;
    result: string;
}

export default {
  getTodayNoticePopupList(comCode: string) : Promise<Array<noticepopup.NoticeItem>>{
    return api.get({
      url: `/Common/NoticePopup/api/list/${comCode}`
    });
  },

  //#region 카운트 관련

  //timezoneoffset param 추가 //일정 정보 조회시 필요함
  getCount(): Promise<home.homeWebpartCount>{
    return api.get({
      url: `/Common/Home/api/count`      
    })
  },
  //#endregion

  /* 토탈시스템 */
  //토탈시스템 링크목록
  search(options?: home.link.GroupSearchOptions): Promise<home.link.GroupSearchResult> {
    if (!options) {
      options = {
          code: null,
          name: null,
          useYn: true,
          systemCode: null
      }
    }
    return api.post<home.link.GroupSearchResult>({
        url: '/common/codeGroup/api/search',
        data: options
    })
  },

  getList(groupCode: string): Promise<home.link.Code[]> {
    return api.get<home.link.Code[]>({
        url: '/common/code/api/getlist?groupCode=' + groupCode
    })
  },

  	/**
	 * 전자결재 미결함 데이터를 조회합니다.
	 * @param req 조회조건
	 * @returns 
	 */
	getDocumentBoxItemList(req: WorkflowRequestDocumentBox) {
        return api.post<WorkflowResponseDocumnetBoxItem>({
            url: "/workflow/documentbox/api/itemlist",
            data: req,
        });
    }
}